 
import styled from 'styled-components';
import Button from 'v3/components/Button';

export const StyledButton = styled(Button)`
  margin-top: 34px;
`;
